import get from "lodash.get";
import {
  archiveCreative,
  unarchiveCreative,
  updateCreative,
} from "./creativesAsyncActions";

export const archiveCreatives = (creativeIds) => {
  return function (dispatch, getState) {
    const { organizationId, accountId } = getState().auth;
    if (!organizationId || !accountId || !creativeIds) return null;

    creativeIds.forEach((cId) => dispatch(archiveCreative(cId)));
  };
};

export const unarchiveCreatives = (creativeIds) => {
  return function (dispatch, getState) {
    const { organizationId, accountId } = getState().auth;
    if (!organizationId || !accountId || !creativeIds) return null;

    creativeIds.forEach((cId) => dispatch(unarchiveCreative(cId)));
  };
};

export const moveCreative = ({ creativeId, tag }) => {
  return function (dispatch, getState) {
    const state = getState();
    const creative =
      get(state, ["creatives", "active", creativeId]) ||
      get(state, ["creatives", "archived", creativeId]);

    if (!creative) return null;

    dispatch(
      updateCreative({
        creative: { ...creative, tag },
      })
    );
  };
};
